export const PRODUCT_CODES = {
  accountingMonthlyBookkeeping: 'ACCOUNTING_Monthly_bookkeeping',
  accountingPersonalTaxFiling: 'ACCOUNTING_Personal_Tax_filing',
  accountingSCorpTaxFiling: 'ACCOUNTING_S_Corp_tax_filing',
  accountingLLCTaxFiling: 'ACCOUNTING_LLC_Tax_filing',
  accountingSolePropTaxFiling: 'ACCOUNTING_Sole_Proprietor_Tax_filing',
  accountingPartnershipTaxFiling: 'ACCOUNTING_Partnership_tax_filing',
  einMonthlyBookkeeping: 'EIN_Monthly_bookkeeping',
  einPersonalTaxFiling: 'EIN_Personal_Tax_filing',
  einLLCTaxFiling: 'EIN_LLC_Tax_filing',
  einSolePropTaxFiling: 'EIN_Sole_Proprietor_Tax_filing',
  incMonthlyBookkeeping: 'INC_Monthly_bookkeeping',
  incPersonalTaxFiling: 'INC_Personal_Tax_filing',
  incLLCTaxFiling: 'INC_LLC_Tax_filing',
  incSolePropTaxFiling: 'INC_Sole_Proprietor_Tax_filing',
  incStatesMonthlyBookkeeping: 'INC_States_Monthly_bookkeeping',
  incStatesPersonalTaxFiling: 'INC_States_Personal_Tax_filing',
  incStatesLLCTaxFiling: 'INC_States_LLC_Tax_filing',
  incStatesSolePropTaxFiling: 'INC_States_Sole_Proprietor_Tax_filing',
  accountingTaxAmendment: 'ACCOUNTING_Tax_Amendment',
  einTaxAmendment: 'EIN_Tax_Amendment',
  incTaxAmendment: 'INC_Tax_Amendment',
  incStatesTaxAmendment: 'INC_States_Tax_Amendment',
};

export const BOOKKEEPING_PRODUCT_CODES_ARR = [
  PRODUCT_CODES.accountingMonthlyBookkeeping,
  PRODUCT_CODES.einMonthlyBookkeeping,
  PRODUCT_CODES.incMonthlyBookkeeping,
  PRODUCT_CODES.incStatesMonthlyBookkeeping,
];
